/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    PHASE3_ADMIN_CARDS
 * Date:         2025-12-20
 * Modified By:  Cursor
 *
 * Description:
 * Admin stats service for dashboard cards.
 * Fetches quick stats from backend for display on admin dashboard.
 */

import axios from 'axios';
import { getAuthHeaders } from '../../utils/authUtils';
import { config } from '../../config/environment';

const API_URL = config.apiUrl;

export interface AdminStats {
  systemStatus: string;
  activeTraces: number;
  recentErrors: number;
  operationsToday: number;
  totalUsers: number;
}

/**
 * Get quick stats for admin dashboard
 */
export async function getAdminStats(): Promise<AdminStats> {
  try {
    const response = await axios.get(`${API_URL}/api/admin/stats`, {
      headers: getAuthHeaders().headers
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch admin stats:', error);
    // Return default values on error
    return {
      systemStatus: 'Unknown',
      activeTraces: 0,
      recentErrors: 0,
      operationsToday: 0,
      totalUsers: 0
    };
  }
}

